import { useAuth0 } from '@auth0/auth0-react';

const SignupPage = () => {
  const { loginWithRedirect } = useAuth0();
  loginWithRedirect({ screen_hint: "signup" });
  return (<></>);
};

export default SignupPage;
